
var id = "denglu";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"denglu\">\n<style type=\"text/css\">\n\t#denglu .st0{fill:#1565C0;}\n</style>\n<path class=\"st0\" d=\"M183.9,163.6c-9.4-22.6-26.5-40.3-48.6-50.2h-0.6c15.5-11.6,24.8-30.4,24.8-50.2c0.6-34.2-26.5-61.8-59.6-61.8\n\tS39.8,28.9,39.8,63.1c0,20.4,9.9,39.2,24.8,50.2h-0.6c-11,5-20.4,11.6-28.7,19.9c-16.6,17.1-26.5,40.3-26.5,64c0,0.6,0,1.1,0.6,1.7\n\tC10,200,10,200,10.6,200h14.3c1.1,0,1.7-1.1,2.2-2.2c0.6-19.3,8.3-37.5,21-50.8c13.2-13.8,32-22.1,51.3-22.1s37.5,7.7,51.3,22.1\n\tc13.2,13.8,21,32,21.5,50.8c0,1.1,1.1,2.2,2.2,2.2h14.3c0.6,0,1.1,0,1.7-0.6s0.6-1.1,0.6-1.7C191.1,186.2,188.3,174.6,183.9,163.6\n\tL183.9,163.6z M100,106.2c-11,0-21.5-4.4-29.3-12.7S58.6,74.7,58.6,63.1S63,41,70.7,32.8S89,20.1,100,20.1s21.5,4.4,29.3,12.7\n\ts12.1,18.8,12.1,30.4s-4.4,22.1-12.1,30.4C121.5,101.8,111,106.2,100,106.2z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
